import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { toggleTheme } from '../../actions';

const ThemeToggleButton = ({ theme, toggleTheme: handleToggleTheme, className }) => {
  const isDarkMode = theme === 'dark';

  const handleToggle = () => {
    handleToggleTheme();
  };

  return (
    <Tooltip title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton
        onClick={handleToggle}
        className={className}
        aria-label="toggle theme"
        style={{ color: 'inherit' }}
      >
        {isDarkMode ? (
          <Brightness7Icon style={{ color: 'inherit' }} />
        ) : (
          <Brightness4Icon style={{ color: 'inherit' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

ThemeToggleButton.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired,
  className: PropTypes.string
};

ThemeToggleButton.defaultProps = {
  className: ''
};

const mapStateToProps = ({ theme: { theme } }) => ({
  theme
});

const actions = {
  toggleTheme
};

export default connect(
  mapStateToProps,
  actions
)(ThemeToggleButton);
